/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/Home.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Home
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Wednesday, September 19, 2018 - 11:18 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/19/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    HOME_LOAD_NAVIGATION
} from '../constants/actionTypes';

const defaultState = {
    refreshList: false,
    navigation: null
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case HOME_LOAD_NAVIGATION:
            return {
                ...state,
                navigation: action.payload[0] ? action.payload[0] : null
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Home.js